var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/search-circle",
    clipPath: "url(#clip0_1982_113)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM10.4078 9.28067L12.5236 11.3965C12.6194 11.5036 12.6705 11.6433 12.6664 11.7869C12.6624 11.9305 12.6036 12.0671 12.502 12.1687C12.4004 12.2703 12.2638 12.3291 12.1202 12.3331C11.9766 12.3371 11.8369 12.286 11.7298 12.1903L9.614 10.0745C8.93587 10.5839 8.11044 10.8588 7.26229 10.8579C5.09588 10.8579 3.33333 9.09537 3.33333 6.92896C3.33333 4.76255 5.09588 3 7.26229 3C9.42871 3 11.1913 4.76255 11.1913 6.92896C11.1922 7.7771 10.9172 8.60253 10.4078 9.28067ZM4.92886 5.36981C4.62049 5.83132 4.45589 6.37391 4.45589 6.92896C4.45679 7.67299 4.75275 8.38629 5.27885 8.9124C5.80496 9.43851 6.51826 9.73447 7.26229 9.73536C7.81735 9.73536 8.35994 9.57077 8.82145 9.2624C9.28296 8.95402 9.64266 8.51573 9.85507 8.00292C10.0675 7.49012 10.1231 6.92585 10.0148 6.38146C9.90648 5.83707 9.6392 5.33702 9.24672 4.94454C8.85424 4.55205 8.35418 4.28477 7.80979 4.17648C7.26541 4.0682 6.70113 4.12377 6.18833 4.33618C5.67553 4.54859 5.23723 4.9083 4.92886 5.36981Z",
    fill: "#616D8D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1982_113"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchCircle);
export default __webpack_public_path__ + "static/media/search-circle.d6b71e9b26713d1ee13f5e1a26c527ce.svg";
export { ForwardRef as ReactComponent };